/**
 * 处理方式常量（选区级：润色 / 缩写 / 扩写 / 降重）
 */
export const PROCESSING_MODE = {
    POLISH: 'polish',
    SHRINK: 'shrink',
    EXPAND: 'expand',
    REDUCE_DUPLICATE: 'reduce-duplicate',
};

/**
 * 操作类型常量
 */
export const ACTION_TYPE = {
    EXPAND: 'expand',
    SHRINK: 'shrink',
    REDUCE_DUPLICATE: 'reduce-duplicate',
    MODIFY_IMAGE: 'modify-image',
    MODIFY_TABLE: 'modify-table',
    MODIFY_FORMULA: 'modify-formula',
    REWRITE_CHAPTER: 'rewrite-chapter',
    POLISH: 'polish',
};

/**
 * 篇幅选项常量
 */
export const LENGTH_OPTION = {
    ORIGINAL: 'original',
    SHRINK: 'shrink',
    NORMAL: 'normal',
    EXPAND: 'expand',
};

/**
 * 语气风格常量
 */
export const TONE_OPTION = {
    ACADEMIC: 'academic',
    PERSUASIVE: 'persuasive',
    FORMAL: 'formal',
    WRITTEN: 'written',
};

/**
 * 面板模式常量：由编辑器里选中的对象决定
 */
export const PANEL_MODE = {
    EMPTY: 'empty',
    SELECTION: 'selection',
    IMAGE: 'image',
    TABLE: 'table',
    FORMULA: 'formula',
    REWRITE_CHAPTER: 'rewrite-chapter',
};

/**
 * 右侧工具面板的两个页签
 */
export const PANEL_TAB = {
    CHAPTER: 'chapter', // 章节改稿
    SELECTION: 'selection', // 局部修改（选中文字 / 图片 / 表格 / 公式）
};

/**
 * 章节改稿的快捷要求：点一下即可填入修改要求
 */
export const REVISE_PRESETS = [
    {
        key: 'rewrite',
        label: '重写',
        text: '重新撰写本节：保持主题、结构和核心观点不变，但使用全新的表述与论证方式。',
    },
    {
        key: 'expand',
        label: '扩写',
        text: '在保留原有结构和观点的基础上扩写本节，补充更多论述细节与数据支撑，篇幅增加约 50%。',
    },
    {
        key: 'shrink',
        label: '精简',
        text: '精简本节内容，去除冗余表述，只保留核心观点与关键论据，篇幅压缩约 30%。',
    },
    {
        key: 'angle',
        label: '换角度',
        text: '换一个切入角度重写本节，调整论证思路与行文顺序，避免与原文表述重复。',
    },
    {
        key: 'case',
        label: '补充案例',
        text: '为本节补充 1~2 个贴切的实际案例或实证数据，并与论点形成呼应。',
    },
    {
        key: 'polish',
        label: '润色',
        text: '在不改变内容与结构的前提下润色本节语言，使表达更学术、更流畅。',
    },
];
